import { RefObject } from "react";
import { IAnalyticsDataItem } from "../types";
import CustomPie from "./Pie";
import AnalitycsItemList from "./AnalyticsItemList";
import { useTranslation } from "react-i18next";

interface ICostPie {
	data: IAnalyticsDataItem[] | null
	is: "projects" | "employees"
	pieRef: RefObject<HTMLDivElement>
}

export default function CostPie({ data, pieRef, is } : ICostPie) {

	const { t } = useTranslation();

	return (
		<div className="analytics-item__block">
			<div className="analytics-item__block-name">
				<b>{t("analytics_page.pie.cost_statistic")}</b>
			</div>
			<div className="analytics-item__block-row">
				<div className="analytics-item__chart" style={{ width: "220px", height: "220px" }}>
					<CustomPie data={data} total="cost" pieRef={pieRef} />
				</div>
				<div className="analytics-item__legend">
					<h3 className="analytics-item__legend-title">{t(`analytics_page.is.${is === "projects" ? "employees" : "projects"}`)} ({data ? data.length : 0}):</h3>
					<AnalitycsItemList data={data} by="cost" />
				</div>
			</div>
		</div>
	)
}